<div class="validation-project-info-container">
  @if (model) {
    <div class="project-info-content">
      <div class="validation-title yellow" [innerHtml]="'validation.project-info.project-header' | translate"></div>
      <div class="project-data-container">
        <div class="project-carousel">
          <p-carousel
            [value]="model.projectImages"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="model.projectImages.length > 1"
            autoplayInterval="7000"
            [showNavigators]="model.projectImages.length > 1">
            <ng-template let-image pTemplate="item">
              <img [src]="image.url" alt="Project Thumbnail" class="gallery-img" (error)="onError($event)" />
            </ng-template>
          </p-carousel>
        </div>
        <div class="project-datas">
          <div class="project-data">
            <span
              class="project-name"
              [innerHtml]="
                'validation.project-info.project-name' | translate: { name: model.projectName ?? '' }
              "></span>
          </div>
          <div class="project-data">
            @if (model.opportunityNumber && model.opportunityNumber > 0) {
              <span
                class="oppotunity-number"
                [innerHTML]="
                  'validation.project-info.' + currentContext + '-opportunity-number'
                    | translate: { number: model.opportunityNumber ?? 0 }
                "></span>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="fidelity-container">
      <div class="title-container">
        <div class="validation-title yellow" [innerHtml]="'validation.project-info.fidelity-header' | translate"></div>
      </div>

      <div class="logged-customer">
        <span>{{ model.loggedCustomerFullName }}</span>
        <ng-casto-circle-btn [faIcon]="faSearch" [color]="'blue'" (click)="openDetailCustomer()"></ng-casto-circle-btn>
      </div>
      <div class="fidelity-card-container">
        <ng-fidelity-card-validation
          [model$]="fidelityCardValidationModel.asObservable()"
          (onRefreshRequested)="refresh()"></ng-fidelity-card-validation>
      </div>
    </div>
  }
</div>
